module.exports = __webpack_public_path__ + "static/media/1023498.3b8c6b8c.png";